/*
 * fn: setSidebarsCookie
 *
 * Sets each sidebar's locked cookie and mirrors it onto the document
 *
 */
import { COOKIE_MAX_AGE } from '@/defs/cookie'
import { SIDEBARS, type SidebarsLockedType } from '@/defs/view'

import { removeCookie } from './removeCookie'
import { setCookie } from './setCookie'

export const setSidebarsCookie = (locked: SidebarsLockedType) => {
  const { dataset } = document.documentElement

  for (const sidebar of SIDEBARS) {
    if (locked[sidebar]) {
      dataset[sidebar] = 'locked'
      setCookie(sidebar, 'locked', { maxAge: COOKIE_MAX_AGE })
    } else {
      delete dataset[sidebar]
      removeCookie(sidebar)
    }
  }
}
